import { StripeIcon } from '@/assets/icons'
import { LockOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
export const StripeAttribution = () => {
  return (
    <div className="payment-attribution">
      <Typography.Text>
        <LockOutlined /> Protected by 128-bit SSL encryption.
      </Typography.Text>
      <StripeIcon />
    </div>
  )
}
